import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Common from "../Common";
import Login_header from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import DatePicker from 'react-datepicker';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AsyncSelect from 'react-select/async';
import * as Picklist from "../Picklist";

const TranUsdConfiguration = () => {
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [srNo, setSrNo] = useState("0");
    const [remark, setRemark] = useState("");
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showFormBtn, setShowFormBtn] = useState(false);
    const [scrMode, setScrMode] = useState('');
    const [usd, setUsd] = useState("");
    const [name, setName] = useState("");
    const [indiSrno, setIndiSrno] = useState("");
    const [onceRun, setOnceRun] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [msgText, setMsgText] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [usdconfigurationdata, setUsdconfigurationtdata] = useState([]);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [tilldate, setTillDate] = useState(new Date());
    const [counter, setCounter] = useState(0);
    const [fileName, setFileName] = useState("");
    const [compareData, setCompareData] = useState([]);
    const [formMode, setFormMode] = useState('Q'); // Q A E 
    const [nIndividual, setNIndividual] = useState(null);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [usdLocation, setUSDLocation] = useState("");
    const [usdLocationCode, setUSDLocationCode] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");
    const [usdStateValue, setUSDStateValue] = useState("");
    const [usdStateType, setUSDStateType] = useState("");
    const [usdStateName, setUSDStateName] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
    const [isAirport, setIsAirport] = useState("0");
    const [filterLocation, setFilterLocation] = useState(null);
    const [individualName, setIndividualName] = useState("");
    const [individualPan, setIndividualPan] = useState("");
    const [individualAddress, setIndividualAddress] = useState("");
    const [status, setStatus] = useState("");
    const [statusUpdateRemark, setStatusUpdateRemark] = useState("");
    const [viewObj, setViewObj] = useState()



    useEffect(() => {
        if (onceRun) return;
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_USD_CONFIGURATION'], function (result) {
            if (result.trim().startsWith('{')) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            } else {
                console.error("Invalid response for rights:", result);
                navigate('/');
            }
        });
        setOnceRun(true);
    }, [onceRun, sid, navigate]);

    const addNew = () => {
        setSrNo(0);
        setRemark("");
        setUSDLocation("");
        setUsd("");
        setName("");
        setIndiSrno("");
        setScrMode('A');
        setNIndividual("");
        setShowAddNewBtn(false);
        setShowFormBtn(true);
        setTillDate(new Date());
        setStatus('1');
        setStatusUpdateRemark('');
        setViewObj();
    };

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    };

    const cancelData = () => {
        setMsgBoxYN(false);
        setShowFormBtn(false);
        setShowAddNewBtn(true);
        setScrMode("");
    };

    const editBtnHandler = () => {
        setScrMode('E')
    }

    const saveData = () => {
        $(".loader").show();
        let i = 0;
        let msg = [];
        msg[i++] = "Please Enter Mandatory Feild";
        !usd && (msg[i++] = "USD");
        !tilldate && (msg[i++] = "Till Date");
        !nIndividual && (msg[i++] = "Indivisual ");
        !usdLocation && (msg[i++] = "Location ");
        !remark && (msg[i++] = "Remark ");
        if (i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        } else {
            // if ((scrMode === 'A' || scrMode === 'E') && !remark.trim()) {
            //     $(".loader").hide();
            //     setMsgText("Please fill Remark!");
            //     setMsgBox(true);
            //     return;
            // }
            const obj = {
                usdconfiguration: usd,
                name: name,
                indiSrno: indiSrno,
                activitytype: srNo > 0 ? 'MODIFY' : 'CREATE',
                srno: srNo,
                subtranno: 0,
                remark: remark,
                tilldate: Common.dateYMD(tilldate),
                status: 0,
                filename: fileName,
                usdLocation: usdLocationCode,
                statusUpdateRemark: statusUpdateRemark
            };
            Common.callApi(Common.apiUsdConfiguration, [sid, 'savelist', srNo, JSON.stringify(obj), JSON.stringify(tranAuditTrail)],
                (result) => {
                    $(".loader").hide();
                    const resp = JSON.parse(result);
                    setUsdconfigurationtdata(resp);
                    setShowFormBtn(false);
                    setShowAddNewBtn(true);
                    setRemark("");
                    setUSDLocation("");
                    setUsd("");
                    setName("");
                    setIndiSrno("");
                    setScrMode('');
                    setMsgText(resp.message || "Successfully Saved!");
                    setMsgBox(true);
                    setViewObj()
                }
            );
        }

    };

    const fillViewCompareObject = (resp) => {
        const obj2 = {
            srno: resp.srno,
            usd: resp.usd,
            name: resp.name,
            indiSrno: resp.indiSrno,
            usdlocation: resp.usdlocation,
            usdLocationCode: resp.usdLocationCode,
            remark: resp.remark,
            tilldate: resp.tilldate
        };
        setCompareData([obj2]);
    };

    const showList = () => {
        $(".loader").show();
        setCounter(counter + 1);

        const obj = {
            usdconfiguration: usd,
            name: name,
            indiSrno: indiSrno,
            srno: 0,
            subtranno: 0,
            remark: remark,
            tilldate: Common.dateYMD(tilldate),
            status: 0,
            fromdate: Common.dateYMD(fromDate),
            todate: Common.dateYMD(toDate),
            usdlocation: filterLocation ? filterLocation.id.split("^")[1] : ""
        };

        Common.callApi(Common.apiUsdConfiguration, [sid, 'getList', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUsdconfigurationtdata(resp);
            // setScrMode('L');
            $(".loader").hide();
        });
    };

    const handleLocationChange = (value) => {
        setUSDLocation(value);
        var id = value.id;
        var location = id.split("^");
        setUSDLocationCode(location[1]);
        setUSDStateValue(location[3] == null ? 0 : location[3]);
        setUSDStateType(location[4]);
        setUSDStateName(location[5] === "" ? "Select" : location[5]);
        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        setIsAirport(location[10]);
        sessionStorage.activeBranch = location[1];
    };

    const handleTravellerChange = (value) => {
        setNIndividual(value);
        var id = value.id.split("^");
        setName(id[2]);
        setIndiSrno(id[1]);
        setIndividualName(id[4]);
        setIndividualPan(id[5]);
        setIndividualAddress(id[6])
    };

    const fillEditForm = (Obj) => {
        setFormMode('Q');
        Common.callApi(Common.apiUsdConfiguration, [sid, 'editList', JSON.stringify(Obj)], (result) => {
            let respon = JSON.parse(result);
            console.log(respon);
            let resp = respon[0];
            console.log(resp);
            setViewObj(resp)
            setSrNo(resp.tuc_srno);
            setUsd(resp.tuc_usd_rate);
            setIndiSrno(resp.tuc_individual_code);
            setRemark(resp.tuc_remark);
            setUSDLocationCode(resp.tuc_location);
            setUSDLocation({
                id: resp.tuc_location,
                label: resp.location_name
            });
            setTillDate(new Date(resp.tuc_till_date));
            // setUsdconfigurationtdata([resp]);
            fillViewCompareObject(resp);
            setShowFormBtn(true);
            setShowAddNewBtn(false);
            setScrMode('Q');
            if (resp?.indi_id && typeof resp.indi_id === 'string') {
                const idParts = resp.indi_id.split('^');
                setName(idParts.length > 2 ? idParts[2] : "");
            }
            else {
                setName("");
            }
            if (resp?.indi_id && resp?.indi_label) {
                setNIndividual({
                    id: resp.indi_id,
                    label: resp.indi_label,
                    desc: resp.indi_desc
                });
            } else {
                setNIndividual(null);
            }
            setStatus(resp.tuc_active);
        });
    };


    return (
        <div>
            <Login_header />
            <Menu />
            <Container fluid>
                <Row><Col><h1>USD Configuration</h1></Col></Row>
                {(scrMode === '') &&
                    <Row className="align-items-center">
                        <Row>
                            <Col md={3}>
                                <Form.Label>Location</Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={(e) => setFilterLocation(e)}
                                    isClearable
                                    placeholder=" Location"
                                />
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Col md={2}>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker
                                className="form-control"
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                placeholderText="Select From Date"
                            />
                        </Col>
                        <Col md={2}>
                            <Form.Label>To Date</Form.Label>
                            <DatePicker
                                className="form-control"
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                placeholderText="Select To Date"
                            />
                        </Col>
                    </Row>
                }
                <Row><Col>&nbsp;</Col></Row>
                {scrMode === '' && showAddNewBtn && userRight.add === "1" &&
                    <Row>
                        <Col>
                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={(e) => showList()}>
                                List
                            </Button>
                            &nbsp;
                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={addNew}>
                                Add New
                            </Button>
                        </Col>
                    </Row>
                }
                <Row>&nbsp;</Row>
                {
                    <Col>
                        {
                            userRight.add === "1" && (scrMode === 'A' || scrMode === 'Q' || scrMode === 'E') ? <>
                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                    cancelConfirm()}>Back</Button>&nbsp;&nbsp;
                            </> : null
                        }
                        {
                            userRight.edit === "1" && (scrMode === 'A' || scrMode === 'E') ? <>
                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                    saveData()}>Save</Button>&nbsp;
                            </> : null
                        }
                        {
                            (userRight.delete === "1" && scrMode === 'Q') ? <>
                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                    editBtnHandler()}>Edit</Button>&nbsp;
                            </> : null
                        }
                    </Col>
                } &nbsp; &nbsp;
                {scrMode == '' &&
                    <Row>
                        <Col>
                            <table className="table table-bordered table-sm">
                                <thead className="thead-light">
                                    <tr>
                                        {userRight.query == "1" && <th></th>}
                                        {/* <th>Sr No</th> */}
                                        <th>Individual Name</th>
                                        <th>Location</th>
                                        <th>USD Rate</th>
                                        <th>Till Date</th>
                                        <th>Created By</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usdconfigurationdata.map((item, index) => (
                                        item ? (
                                            <tr key={index + 1}>
                                                {scrMode !== 'Q' && userRight.query == "1" && (
                                                    <td className="textCenter">
                                                        <span className="handCursor" onClick={() => fillEditForm({ tuc_srno: item.tuc_srno })} >
                                                            <div className="colorThemeBlue">
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </div>
                                                        </span>
                                                    </td>
                                                )}
                                                {/* <td>{item.tuc_srno}</td> */}
                                                <td>{item.bd_name}</td>
                                                <td>{item.location_name}</td>
                                                <td>{item.tuc_usd_rate}</td>
                                                <td>{item.tuc_till_date}</td>
                                                <td>{item.tuc_created_by + ' ' + item.um_username}</td>
                                                <td>{item.tuc_remark}</td>
                                            </tr>
                                        ) : null
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                }
                <Row><Col>&nbsp;</Col></Row>
                {showFormBtn && (scrMode === 'A' || scrMode === 'Q' || scrMode === 'E') &&
                    <>
                        <Row>
                            <Col>
                                <p>Created By : <b>{(viewObj?.tuc_created_by || '') + ' ' + (viewObj?.created_by || '')}</b></p>
                            </Col>
                            <Col>
                                <p>Created Date : <b>{viewObj?.created_date || ''}</b></p>
                            </Col>
                            {viewObj?.tuc_expire_by &&
                                <Col>
                                    <p>Expired By : <b>{(viewObj?.tuc_expire_by || '') + ' ' + (viewObj?.expire_by || '')}</b></p>
                                </Col>
                            }
                            {viewObj?.expired_date &&
                                <Col>
                                    <p>Expired Date : <b>{viewObj?.expired_date || ''}</b></p>
                                </Col>
                            }

                        </Row>
                        <Row>
                            <Col className="divContentCenter">
                                <div className="maxFormWidth">
                                    <Form>
                                        <Row>
                                            {/* <Col>
                                            <Form.Group>
                                                <Form.Label>Serial Number</Form.Label>
                                                <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                            </Form.Group>
                                        </Col> */}
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={usdLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleLocationChange}
                                                        isDisabled={scrMode === 'Q' || scrMode === 'E' || branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>USD RATE<span className="mandatory text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="USD" maxLength={10}
                                                        value={usd}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, setUsd)}
                                                        disabled={scrMode === 'Q' || scrMode === 'E'}
                                                        autoComplete="off" />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Till Date <span className=" text-danger">*</span></Form.Label><br></br>
                                                    <DatePicker className="form-control"
                                                        selected={tilldate}
                                                        minDate={new Date()}
                                                        onChange={(date) => setTillDate(date)}
                                                        disabled={scrMode === 'Q'}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Individual Name<span className="colorThemeRed">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={nIndividual}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchIndividualPicklist(search, "SALE")}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleTravellerChange}
                                                            isDisabled={scrMode === "Q" || scrMode === 'E'}
                                                            formatOptionLabel={Picklist.formatOptionLabel}
                                                            components={{ Menu: Picklist.menu }}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Row>
                                        {/* {userRight.delete} */}
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select value={status} onChange={e => setStatus(e.target.value)}
                                                        disabled={!(userRight.delete == "1" && scrMode === 'E')}
                                                        required >
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Remark" maxLength={500}
                                                        value={remark}
                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                        disabled={scrMode === 'Q' || scrMode === 'E'}
                                                        autoComplete="off"
                                                        required />
                                                </Form.Group>
                                            </Col>
                                            {scrMode === 'E' &&
                                                <Col className='col-md-9 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Status Update Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Status Update Remark" maxLength={1000}
                                                            value={statusUpdateRemark}
                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setStatusUpdateRemark)}
                                                            disabled={scrMode === 'Q'}
                                                            autoComplete="off"
                                                            required />
                                                    </Form.Group>
                                                </Col>
                                            }

                                        </Row>
                                        &nbsp; &nbsp;
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </>
                }
                <Row>
                </Row>&nbsp;
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </div>
    )

}
export default TranUsdConfiguration;